import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserLogService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  mesEnCurso(id:string) {
    return this.http.get(this.myAppUrl + 'api/userlog/mesencurso/' + id);
  }

  mesPasado(id: string) {
    return this.http.get(this.myAppUrl + 'api/userlog/mespasado/' + id);
  }

  diaEnCurso(id: string) {
    return this.http.get(this.myAppUrl + 'api/userlog/diaencurso/' + id);
  }
}
